import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import { useAuthStore } from '@/pinia/authorization/useAuthStore'
// import { storeToRefs } from 'pinia'
// import { onMounted } from 'vue'
//
// const { init, authLogout } = useAuthStore()
// const { menuItems, userData } = storeToRefs(useAuthStore())
// onMounted(() => {
//   init()
// })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})